import qs from 'query-string';
import { useSearchParams } from 'react-router-dom';
export function useQueryParams() {
    const [searchParams] = useSearchParams();
    const parsedSearchParams = qs.parse(searchParams.toString(), {
        arrayFormat: 'bracket'
    });
    return parsedSearchParams;
}
//# sourceMappingURL=index.js.map